var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.result)?_c('b-card-body',[_c('table',{staticClass:"table table-md mb-3"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Orders")]),_c('th',[_vm._v("Shipped on time")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.result.orders))]),_c('td',[_vm._v(_vm._s(_vm.result.data)+"%")])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }